export default "__VITE_ASSET__BEJ8M6ax__"